export default __webpack_public_path__ + "static/media/Skill.a519eadf.png";